import { createAsyncThunk } from "@reduxjs/toolkit";
import { contactService } from "../../../services/contactService";

export const sendContactForm = createAsyncThunk(
  "contact/sendContactForm",
  async (contactData, { rejectWithValue }) => {
    try {
      return await contactService.sendContactForm(contactData);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Greška pri slanju poruke"
      );
    }
  }
);